<template>
  <v-tooltip right>
    <template v-slot:activator="{ on }">
      <v-icon color="error">warning</v-icon>
      <v-btn color="primary" dark v-on="on"></v-btn>
    </template>
    <span>{{$tf('CapsLock activated')}}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'CapsLockWarning'
}
</script>

<style scoped>

</style>
